import { request, ResponseData } from "../instance";
import {
  Series,
  Reminder,
  SaveReminderClockParams,
  CourseDetail,
} from "./courseTypes";
const headers = { "Content-Type": "application/json" };

export const getAllSeriesCourses = async (): Promise<
  ResponseData<Series[]>
> => {
  const resp = await request("course/series");
  return resp;
};

export const getAllCourses = async (): Promise<ResponseData<any>> => {
  const resp = await request("course/new/allCourses");
  return resp;
};

export const getCourseReminder = async (
  courseId: string | undefined
): Promise<ResponseData<Reminder[]>> => {
  let url = `course/alarm/info?courseId=${courseId}`;
  const resp = await request(url);
  return resp;
};

export const updateCourseReminder = async (
  data: SaveReminderClockParams
): Promise<ResponseData> => {
  const resp = await request("course/alarm/update", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const getMyCoursesOld = async (): Promise<
  ResponseData<CourseDetail[]>
> => {
  const resp = await request("course/myCourses");
  return resp;
};

export const getMyCourses = async (): Promise<ResponseData<any>> => {
  const resp = await request("course/new/myCourses");
  return resp;
};

export const getCourseInfoById = async (
  id: string | undefined
): Promise<ResponseData<CourseDetail>> => {
  let url = `course/info?id=${id}`;
  const resp = await request(url);
  return resp;
};

export const getCoursePageSettings = async (
  configType: string
): Promise<ResponseData<any>> => {
  const resp = await request(`user/config/info?configType=${configType}`);
  return resp;
};

export const updateCourseSettings = async (
  data: any
): Promise<ResponseData> => {
  const resp = await request("user/config/update", {
    method: "POST",
    data,
    headers,
  });
  return resp;
};

export const getWorkPanelSettings = async (): Promise<ResponseData> => {
  const resp = await request("community/work/list", {
    method: "POST",
    data: { workName: "", page: 1, usePage: false },
    headers,
  });
  return resp;
};

export const getControlPanelSettings = async (): Promise<ResponseData<any>> => {
  const resp = await request(`course/new/console`);
  return resp;
};

export const pushWorkItemTop = async (
  workId: string,
  isTop: Boolean
): Promise<ResponseData> => {
  const resp = await request("community/work/top", {
    method: "POST",
    data: { workId: workId, top: isTop },
    headers,
  });
  return resp;
};

export const updateCourseStart = async (
  lessonId: string
): Promise<ResponseData<any>> => {
  const resp = await request(`course/new/learn/enter?lessonId=${lessonId}`);
  return resp;
};
